/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Vo_Track_FailedInputs */

const en_audio_description_export_vo_track_failed = /** @type {(inputs: Audio_Description_Export_Vo_Track_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error exporting VO Track`)
};

const fr_audio_description_export_vo_track_failed = /** @type {(inputs: Audio_Description_Export_Vo_Track_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de l'export de la piste VO`)
};

const de_audio_description_export_vo_track_failed = /** @type {(inputs: Audio_Description_Export_Vo_Track_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Exportieren der Sprachspur`)
};

const it_audio_description_export_vo_track_failed = /** @type {(inputs: Audio_Description_Export_Vo_Track_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore durante l'esportazione della traccia VO`)
};

const ru_audio_description_export_vo_track_failed = /** @type {(inputs: Audio_Description_Export_Vo_Track_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка при экспорте аудиодорожки.`)
};

const es_audio_description_export_vo_track_failed = /** @type {(inputs: Audio_Description_Export_Vo_Track_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al exportar la pista VO`)
};

const zh_cn2_audio_description_export_vo_track_failed = /** @type {(inputs: Audio_Description_Export_Vo_Track_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出语音轨道时出错`)
};

const ja_audio_description_export_vo_track_failed = /** @type {(inputs: Audio_Description_Export_Vo_Track_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VOトラックのエクスポート中にエラーが発生しました`)
};

const hi_audio_description_export_vo_track_failed = /** @type {(inputs: Audio_Description_Export_Vo_Track_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीओ ट्रैक निर्यात करने में त्रुटि`)
};

const pt_pt2_audio_description_export_vo_track_failed = /** @type {(inputs: Audio_Description_Export_Vo_Track_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao exportar a faixa de voz`)
};

/**
* | output |
* | --- |
* | "Error exporting VO Track" |
*
* @param {Audio_Description_Export_Vo_Track_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_vo_track_failed = /** @type {((inputs?: Audio_Description_Export_Vo_Track_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Vo_Track_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_vo_track_failed(inputs)
	if (locale === "de") return de_audio_description_export_vo_track_failed(inputs)
	if (locale === "it") return it_audio_description_export_vo_track_failed(inputs)
	if (locale === "ru") return ru_audio_description_export_vo_track_failed(inputs)
	if (locale === "es") return es_audio_description_export_vo_track_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_vo_track_failed(inputs)
	if (locale === "ja") return ja_audio_description_export_vo_track_failed(inputs)
	if (locale === "hi") return hi_audio_description_export_vo_track_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_vo_track_failed(inputs)
	return en_audio_description_export_vo_track_failed(inputs)
});